import _regenerator from "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _createForOfIteratorHelper from "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
/**
 * 自动配置各类语言包
 * */
import { merge } from 'lodash';
import Setting from '@/setting';
import { I18nList } from '@api/system/i18n';

// 导入 View UI Plus 语言包
var ViewUIPlusLocale = require.context('view-ui-plus/dist/locale', false, /.+\-.+.js$/);

// 导入布局语言包
import layoutLocale from '@/layouts/basic-layout/i18n';

// 页面语言包
var sysPageLocale = require.context('@/sys-pages', true, /i18n.js/);
var pageLocale = require.context('@/pages', true, /i18n.js/);

// 菜单语言包
var menuLocale = require.context('@/menu', true, /i18n.js/);

// 组件语言包
var componentLocale = require.context('@/components', true, /i18n.js/);

/**
 * @description 配置本地语言包
 * */
function loadNativeLocaleMessages() {
  var messages = {};
  var _iterator = _createForOfIteratorHelper(Setting.i18n.list),
    _step;
  try {
    var _loop = function _loop() {
      var lang = _step.value;
      messages[lang.locale] = {
        page: {},
        menu: {},
        component: {}
      };

      // 设置 View UI Plus 语言包
      ViewUIPlusLocale.keys().forEach(function (path) {
        var currentLocale = ViewUIPlusLocale(path).default;
        if (currentLocale.i.locale === lang.locale) {
          Object.keys(currentLocale).forEach(function (key) {
            messages[lang.locale][key] = currentLocale[key];
          });
        }
      });

      // 设置 Layout 语言包
      Object.keys(layoutLocale).forEach(function (locale) {
        if (lang.locale === locale) {
          Object.keys(layoutLocale[locale]).forEach(function (key) {
            messages[lang.locale][key] = layoutLocale[locale][key];
          });
        }
      });

      // 设置页面语言包
      sysPageLocale.keys().forEach(function (path) {
        var currentPage = sysPageLocale(path).default[lang.locale];
        if (currentPage) {
          Object.keys(currentPage).forEach(function (key) {
            messages[lang.locale].page[key] = currentPage[key];
          });
        }
      });
      pageLocale.keys().forEach(function (path) {
        var currentPage = pageLocale(path).default[lang.locale];
        if (currentPage) {
          Object.keys(currentPage).forEach(function (key) {
            messages[lang.locale].page[key] = currentPage[key];
          });
        }
      });

      // 设置菜单语言包
      menuLocale.keys().forEach(function (path) {
        var currentMenu = menuLocale(path).default[lang.locale];
        if (currentMenu) {
          Object.keys(currentMenu).forEach(function (key) {
            messages[lang.locale].menu[key] = currentMenu[key];
          });
        }
      });

      // 设置组件语言包
      componentLocale.keys().forEach(function (path) {
        var currentComponent = componentLocale(path).default[lang.locale];
        if (currentComponent) {
          Object.keys(currentComponent).forEach(function (key) {
            messages[lang.locale].component[key] = currentComponent[key];
          });
        }
      });
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return messages;
}
export default loadNativeLocaleMessages();

/**
 * @description 配置远程接口语言包
 * */
export function loadRemoteLocaleMessages(_x) {
  return _loadRemoteLocaleMessages.apply(this, arguments);
}
function _loadRemoteLocaleMessages() {
  _loadRemoteLocaleMessages = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(i18n) {
    var nativeMessages, remoteMessages, messages;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          nativeMessages = loadNativeLocaleMessages();
          _context.n = 1;
          return I18nList();
        case 1:
          remoteMessages = _context.v;
          messages = merge({}, nativeMessages, remoteMessages);
          Object.keys(messages).forEach(function (key) {
            i18n.global.setLocaleMessage(key, messages[key]);
          });
        case 2:
          return _context.a(2);
      }
    }, _callee);
  }));
  return _loadRemoteLocaleMessages.apply(this, arguments);
}